module.exports = __webpack_public_path__ + "static/media/sunglasses.77922677.jpg";